import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { connect } from 'react-redux';

import { BackstageLoggerDefaultArgs } from '../../constants';
import * as D from '../../deps';

const { AUDIO_PLAY_TRACK, PAUSE } = D.Constants.AudioPlayer.AudioPlayerActions;
const { SHARE } = D.Constants.SourceCard.SourceCardConstants;

export function useClickControls(props) {
  const { integration } = useContext(D.AppContext);
  const {
    curatorPandoraId,
    playablePandoraId,
    playableContentType,
    shareableUrlPath,
    showPremiumAccess,
    playResumeSource,
    pauseTrack,
    openShareModal,
  } = props;

  const logClickEvent = (componentEventType, pandoraId) => {
    integration.action.clicked({
      ...BackstageLoggerDefaultArgs.controlBar,
      ...{ pandoraId, componentEventType },
    });
  };

  const playOnClick = () => {
    logClickEvent(AUDIO_PLAY_TRACK, playablePandoraId);
    playResumeSource({
      id: playablePandoraId,
      pandoraType: playableContentType,
      forceRestartSourceIfPlaying: showPremiumAccess,
      context: D.Constants.Ads.Rewards.ContextTypes.BACKSTAGE,
      pageUrl: shareableUrlPath,
    });
  };

  const pauseOnClick = () => {
    logClickEvent(PAUSE, playablePandoraId);
    pauseTrack();
  };

  const onShareClick = () => {
    logClickEvent(SHARE);
    openShareModal(curatorPandoraId, {
      shareParentSourceId: curatorPandoraId,
      shareParentSourceType: D.PandoraTypes.CURATOR,
    });
  };

  return {
    playOnClick,
    pauseOnClick,
    onShareClick,
  };
}

export function mapStateToProps(state) {
  return {
    showPremiumAccess: D.Utils.Listener.showPremiumAccess(state),
  };
}

const mapDispatchToProps = {
  playResumeSource: D.playResumeSource,
  pauseTrack: D.pauseTrack,
  openModal: D.openModal,
  closeModal: D.closeModal,
  openShareModal: D.openShareModal,
};

export function withCuratorButtonControls(WrappedComponent) {
  const CuratorButtonControls = props => {
    const { playOnClick, pauseOnClick, onShareClick } = useClickControls(props);

    return (
      <WrappedComponent
        playOnClick={playOnClick}
        pauseOnClick={pauseOnClick}
        onShareClick={onShareClick}
        {...props}
      />
    );
  };

  CuratorButtonControls.propTypes = {
    curatorPandoraId: PropTypes.string,
    playablePandoraId: PropTypes.string,
    shareableUrlPath: PropTypes.string,
    playableContentType: PropTypes.string,
    showPremiumAccess: PropTypes.bool,
    playResumeSource: PropTypes.func,
    pauseTrack: PropTypes.func,
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    openShareModal: PropTypes.func,
  };

  return connect(mapStateToProps, mapDispatchToProps)(CuratorButtonControls);
}
